var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6C4.89543 4 4 4.89543 4 6V16.9473L4.72456 15.8604C5.54042 14.6367 7.12316 14.1848 8.46212 14.7934L11.0258 15.9588C11.4357 16.1451 11.9196 16.0345 12.2079 15.6886L14.9202 12.4338C15.999 11.1392 17.9322 10.9869 19.2004 12.0966L20 12.7962V6C20 4.89543 19.1046 4 18 4ZM6 20C5.50026 20 5.04333 19.8167 4.69276 19.5137L6.38867 16.9698C6.66062 16.5619 7.1882 16.4113 7.63452 16.6142L10.1982 17.7795C11.4279 18.3384 12.8795 18.0066 13.7443 16.9689L16.4566 13.7141C16.8162 13.2826 17.4606 13.2318 17.8834 13.6017L20 15.4538V18C20 19.1046 19.1046 20 18 20H6ZM6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9ZM12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9Z",
    fill: "#006B6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotos);
export default __webpack_public_path__ + "static/media/ic_photos.6c8777d347cbbd2d2d56b92de58c26b9.svg";
export { ForwardRef as ReactComponent };